module.exports = __webpack_public_path__ + "img/banner.766081c.jpg";